module.exports = __webpack_public_path__ + "static/media/1-1-1.e5322ff7.png";